
import { ObserveVisibility } from 'vue-observe-visibility';

// eslint-disable-next-line object-shorthand
export default {
  name: 'SearchInput',

  data() {
    return {
      headers: [],
      sections: [],
      dictionaryPlaceholders: [],

      deferredSearch: null,
      timeOutSetPlaceholder: null,
      totalSearchCount: 0,

      activeCategory: '',
      searchInput: '',

      isVisibleDropDown: false,
      isLoading: false,
    };
  },

  components: {
    LazySearchDropdown: () => import('~/components/widgets/SearchHome/LazySearchDropdown'),
  },

  props: {
    pseudoSearchStrings: {
      type: Array,
      default: () => [],
    },

    isNeedAnimation: {
      type: Boolean,
      default: false,
    },

    isHeader: {
      type: Boolean,
      default: false,
    },
  },

  directives: {
    ObserveVisibility,
  },

  methods: {
    onChangeSearch({ target }) {
      this.search = target.value;
      this.isVisibleDropDown = true;

      clearTimeout(this.deferredSearch);

      this.isLoading = Boolean((target.value || '').length >= 2);
      if (!target.value || target.value.length < 2) {
        return null;
      }

      this.deferredSearch = setTimeout(async () => {
        await this.getContent();
      }, 500);

      return true;
    },

    dropDownClose() {
      this.isVisibleDropDown = false;
      this.searchInput = '';
      this.headers = [];
      this.sections = [];
      this.totalSearchCount = 0;
    },

    async getContent() {
      this.isLoading = true;

      const { data: response } = await this.$api.agent.transport.get(
        `catalog/search?query=${this.searchInput}&expand=characteristicGroup`,
      );
      const content = response?.results || {};

      const totalCount = Object.keys(content || {})
        .reduce((prev, current) => prev + (content[current]?.items || []).length, 0);

      const headers = [
        { id: '', title: 'Все результаты', value: totalCount },
      ];

      // Сборка поиска (HEADER)
      Object.keys(content || {}).forEach((key, index) => {
        const item = content[key];

        headers.push({
          id: index + 1,
          title: item.name,
          value: (content?.[key]?.items || []).length,
        });
      });

      const sections = [];
      Object.keys(content || {}).forEach((key, index) => {
        const item = content[key];

        sections.push({
          id: index + 1,
          title: item.name,
          type: key,
          length: (content?.[key]?.items || []).length,
          items: content?.[key]?.items,
        });
      });

      this.headers = headers;
      this.sections = sections;
      this.totalSearchCount = totalCount;

      this.isLoading = false;
    },

    setActiveCategory(id) {
      if (this.activeCategory === id) {
        this.activeCategory = '';

        return null;
      }

      this.activeCategory = id;
      return true;
    },

    goPageSearch() {
      if ((this.search || '').length < 3) {
        return null;
      }

      this.dropDownClose();

      this.$router.push(`/search?search=${this.search}`);

      return true;
    },
  },

  mounted() {
    if (this.isNeedAnimation) {
      this.setDictionaryPlaceholders();
    }
  },

};
